export class DateTimeF {
    // Id stored in the db/user account.
    dateTimeFormatId?: number;
    // Add more types, as needed.
    type?: 'date' | 'time';
    translationKey?: string;
    // Use this for moment() date/time formatting.
    dateTimeFormat?: string;
    // https://api.highcharts.com/highcharts/xAxis.dateTimeLabelFormats
    hcDateTimeFormat?: {
        millisecond?: string,
        second?: string,
        minute?: string,
        hour?: string,
        day?: string,
        week?: string,
        month?: string,
        year?: string
    }|'NONE';
    hcToolTipDateTimeFormat?: {
        millisecond?: string,
        second?: string,
        minute?: string,
        hour?: string,
        day?: string,
        week?: string,
        month?: string,
        year?: string
    }|'NONE';
    customHcFormat?: string;
    customHcFormats?: string;
    hcAxisFormat?: string;
    // Used for js Date.toLocaleTimeString() as a default.
    localeDateString?: string;

    /**
     * Get the dateFormat object moment date format property value.
     * @param dateTimeFormat - Dete/Time format object.
     */
    static getMomentFormat(dateTimeFormat: DateTimeF) {
        let momentFormat = null;
        if (dateTimeFormat.hasOwnProperty('dateTimeFormat') && dateTimeFormat.dateTimeFormat!.length &&
            dateTimeFormat.dateTimeFormat !== 'NONE') {
            momentFormat = dateTimeFormat.dateTimeFormat;
        }
        return momentFormat;
    }

    /**
     * Get the Highcharts date/time format object - xAxis
     * @param dateTimeFormat - current date/time format.
     * @return Object - hcDateTimeFormat object.
     */
    static getHCFormat(dateTimeFormat: DateTimeF) {
        let hcFormat = null;
        if (dateTimeFormat.hasOwnProperty('hcDateTimeFormat') && Object.keys(dateTimeFormat.hcDateTimeFormat!).length &&
            dateTimeFormat.hcDateTimeFormat !== 'NONE') {
            hcFormat = dateTimeFormat.hcDateTimeFormat;
        }
        return hcFormat;
    }

    /**
     * Get the Highcharts date/time format object - tooltip
     * @param dateTimeFormat - current date/time format.
     * @return Object - hcDateTimeFormat object.
     */
    static getHCToolTipFormat(dateTimeFormat: DateTimeF) {
        let hcFormat = null;
        if (dateTimeFormat.hasOwnProperty('hcToolTipDateTimeFormat') && Object.keys(dateTimeFormat.hcToolTipDateTimeFormat!).length &&
            dateTimeFormat.hcToolTipDateTimeFormat !== 'NONE') {
            hcFormat = dateTimeFormat.hcToolTipDateTimeFormat;
        }
        return hcFormat;
    }

}

/*
    HighCharts date format strings.
    //-- Day
    // Short weekday, like 'Mon'
    'a': shortWeekdays ?
        shortWeekdays[day] :
        langWeekdays[day].substr(0, 3),
    // Long weekday, like 'Monday'
    'A': langWeekdays[day],
    // Two digit day of the month, 01 to 31
    'd': pad(dayOfMonth),
    // Day of the month, 1 through 31
    'e': pad(dayOfMonth, 2, ' '),
    'w': day,

    // Week (none implemented)
    //'W': weekNumber(),

    //-- Month
    // Short month, like 'Jan'
    'b': lang.shortMonths[month],
    // Long month, like 'January'
    'B': lang.months[month],
    // Two digit month number, 01 through 12
    'm': pad(month + 1),

    //-- Year
    // Two digits year, like 09 for 2009
    'y': fullYear.toString().substr(2, 2),
    // Four digits year, like 2009
    'Y': fullYear,

    //-- Time
    // Two digits hours in 24h format, 00 through 23
    'H': pad(hours),
    // Hours in 24h format, 0 through 23
    'k': hours,
    // Two digits hours in 12h format, 00 through 11
    'I': pad((hours % 12) || 12),
    // Hours in 12h format, 1 through 12
    'l': (hours % 12) || 12,
    // Two digits minutes, 00 through 59
    'M': pad(date[D.hcGetMinutes]()),
    // Upper case AM or PM
    'p': hours < 12 ? 'AM' : 'PM',
    // Lower case AM or PM
    'P': hours < 12 ? 'am' : 'pm',
    // Two digits seconds, 00 through  59
    'S': pad(date.getSeconds()),
    // Milliseconds (naming from Ruby)
    'L': pad(Math.round(timestamp % 1000), 3)
*/
